"use strict";

var _slicedToArray = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var parse5 = require("parse5");

var sax = require("sax");

var attributes = require("../living/attributes");

var DocumentType = require("../living/generated/DocumentType");

var JSDOMParse5Adapter = require("./parse5-adapter-parsing");

var _require = require("../living/helpers/namespaces"),
    HTML_NS = _require.HTML_NS; // Horrible monkey-patch to implement https://github.com/inikulin/parse5/issues/237


var OpenElementStack = require("parse5/lib/parser/open_element_stack");

var originalPop = OpenElementStack.prototype.pop;

OpenElementStack.prototype.pop = function () {
  var before = this.items[this.stackTop];

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  originalPop.apply(this, args);

  if (before._poppedOffStackOfOpenElements) {
    before._poppedOffStackOfOpenElements();
  }
};

var originalPush = OpenElementStack.prototype.push;

OpenElementStack.prototype.push = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  originalPush.apply(this, args);
  var after = this.items[this.stackTop];

  if (after._pushedOnStackOfOpenElements) {
    after._pushedOnStackOfOpenElements();
  }
};

module.exports = /*#__PURE__*/function () {
  function HTMLToDOM(parsingMode) {
    _classCallCheck(this, HTMLToDOM);

    this.parser = parsingMode === "xml" ? sax : parse5;
  }

  _createClass(HTMLToDOM, [{
    key: "appendToNode",
    value: function appendToNode(html, node) {
      html = String(html);
      return this._doParse(html, true, node);
    }
  }, {
    key: "appendToDocument",
    value: function appendToDocument(html, documentImpl) {
      html = String(html);
      return this._doParse(html, false, documentImpl, documentImpl._parseOptions);
    }
  }, {
    key: "_doParse",
    value: function _doParse() {
      return this.parser === parse5 ? this._parseWithParse5.apply(this, arguments) : this._parseWithSax.apply(this, arguments);
    }
  }, {
    key: "_parseWithParse5",
    value: function _parseWithParse5(html, isFragment, contextNode) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var adapter = new JSDOMParse5Adapter(contextNode._ownerDocument || contextNode);
      options.treeAdapter = adapter;

      if (isFragment) {
        var fragment = this.parser.parseFragment(contextNode, html, options);

        if (contextNode._templateContents) {
          contextNode._templateContents.appendChild(fragment);
        } else {
          contextNode.appendChild(fragment);
        }
      } else {
        this.parser.parse(html, options);
      }

      return contextNode;
    }
  }, {
    key: "_parseWithSax",
    value: function _parseWithSax(html, isFragment, contextNode) {
      var SaxParser = this.parser.parser;
      var parser = new SaxParser(
      /* strict = */
      true, {
        xmlns: true,
        strictEntities: true
      });
      parser.noscript = false;
      parser.looseCase = "toString";
      var openStack = [contextNode];

      parser.ontext = function (text) {
        setChildForSax(openStack[openStack.length - 1], {
          type: "text",
          data: text
        });
      };

      parser.oncdata = function (cdata) {
        setChildForSax(openStack[openStack.length - 1], {
          type: "cdata",
          data: cdata
        });
      };

      parser.onopentag = function (arg) {
        var attrs = Object.keys(arg.attributes).map(function (key) {
          var rawAttribute = arg.attributes[key];
          var prefix = rawAttribute.prefix;
          var localName = rawAttribute.local;

          if (prefix === "xmlns" && localName === "") {
            // intended weirdness in node-sax, see https://github.com/isaacs/sax-js/issues/165
            localName = prefix;
            prefix = null;
          }

          if (prefix === "") {
            prefix = null;
          }

          var namespace = rawAttribute.uri === "" ? null : rawAttribute.uri;
          return {
            name: rawAttribute.name,
            value: rawAttribute.value,
            prefix: prefix,
            localName: localName,
            namespace: namespace
          };
        });
        var tag = {
          type: "tag",
          name: arg.local,
          prefix: arg.prefix,
          namespace: arg.uri,
          attributes: attrs
        };

        if (arg.local === "script" && arg.uri === HTML_NS) {
          openStack.push(tag);
        } else {
          var elem = setChildForSax(openStack[openStack.length - 1], tag);
          openStack.push(elem);
        }
      };

      parser.onclosetag = function () {
        var elem = openStack.pop();

        if (elem.constructor.name === "Object") {
          // we have an empty script tag
          setChildForSax(openStack[openStack.length - 1], elem);
        }
      };

      parser.onscript = function (scriptText) {
        var tag = openStack.pop();
        tag.children = [{
          type: "text",
          data: scriptText
        }];
        var elem = setChildForSax(openStack[openStack.length - 1], tag);
        openStack.push(elem);
      };

      parser.oncomment = function (comment) {
        setChildForSax(openStack[openStack.length - 1], {
          type: "comment",
          data: comment
        });
      };

      parser.onprocessinginstruction = function (pi) {
        setChildForSax(openStack[openStack.length - 1], {
          type: "directive",
          name: "?" + pi.name,
          data: "?" + pi.name + " " + pi.body + "?"
        });
      };

      parser.ondoctype = function (dt) {
        setChildForSax(openStack[openStack.length - 1], {
          type: "directive",
          name: "!doctype",
          data: "!doctype " + dt
        });
        var entityMatcher = /<!ENTITY ([^ ]+) "([^"]+)">/g;
        var result;

        while (result = entityMatcher.exec(dt)) {
          var _result = result,
              _result2 = _slicedToArray(_result, 3),
              name = _result2[1],
              value = _result2[2];

          if (!(name in parser.ENTITIES)) {
            parser.ENTITIES[name] = value;
          }
        }
      };

      parser.onerror = function (err) {
        throw err;
      };

      parser.write(html).close();
    }
  }]);

  return HTMLToDOM;
}();

function setChildForSax(parentImpl, node) {
  var currentDocument = parentImpl && parentImpl._ownerDocument || parentImpl;
  var newNode;
  var isTemplateContents = false;

  switch (node.type) {
    case "tag":
    case "script":
    case "style":
      newNode = currentDocument._createElementWithCorrectElementInterface(node.name, node.namespace);
      newNode._prefix = node.prefix || null;
      newNode._namespaceURI = node.namespace || null;
      break;

    case "root":
      // If we are in <template> then add all children to the parent's _templateContents; skip this virtual root node.
      if (parentImpl.tagName === "TEMPLATE" && parentImpl._namespaceURI === HTML_NS) {
        newNode = parentImpl._templateContents;
        isTemplateContents = true;
      }

      break;

    case "text":
      // HTML entities should already be decoded by the parser, so no need to decode them
      newNode = currentDocument.createTextNode(node.data);
      break;

    case "cdata":
      newNode = currentDocument.createCDATASection(node.data);
      break;

    case "comment":
      newNode = currentDocument.createComment(node.data);
      break;

    case "directive":
      if (node.name[0] === "?" && node.name.toLowerCase() !== "?xml") {
        var data = node.data.slice(node.name.length + 1, -1);
        newNode = currentDocument.createProcessingInstruction(node.name.substring(1), data);
      } else if (node.name.toLowerCase() === "!doctype") {
        newNode = parseDocType(currentDocument, "<" + node.data + ">");
      }

      break;
  }

  if (!newNode) {
    return null;
  }

  if (node.attributes) {
    var _iterator = _createForOfIteratorHelper(node.attributes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        attributes.setAttributeValue(newNode, a.localName, a.value, a.prefix, a.namespace);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (node.children) {
    for (var c = 0; c < node.children.length; c++) {
      setChildForSax(newNode, node.children[c]);
    }
  }

  if (!isTemplateContents) {
    if (parentImpl._templateContents) {
      // Setting innerHTML on a <template>
      parentImpl._templateContents.appendChild(newNode);
    } else {
      parentImpl.appendChild(newNode);
    }
  }

  return newNode;
}

var HTML5_DOCTYPE = /<!doctype html>/i;
var PUBLIC_DOCTYPE = /<!doctype\s+([^\s]+)\s+public\s+"([^"]+)"\s+"([^"]+)"/i;
var SYSTEM_DOCTYPE = /<!doctype\s+([^\s]+)\s+system\s+"([^"]+)"/i;

function parseDocType(doc, html) {
  if (HTML5_DOCTYPE.test(html)) {
    return createDocumentTypeInternal(doc, "html", "", "");
  }

  var publicPieces = PUBLIC_DOCTYPE.exec(html);

  if (publicPieces) {
    return createDocumentTypeInternal(doc, publicPieces[1], publicPieces[2], publicPieces[3]);
  }

  var systemPieces = SYSTEM_DOCTYPE.exec(html);

  if (systemPieces) {
    return createDocumentTypeInternal(doc, systemPieces[1], "", systemPieces[2]);
  } // Shouldn't get here (the parser shouldn't let us know about invalid doctypes), but our logic likely isn't
  // real-world perfect, so let's fallback.


  return createDocumentTypeInternal(doc, "html", "", "");
}

function createDocumentTypeInternal(ownerDocument, name, publicId, systemId) {
  return DocumentType.createImpl([], {
    ownerDocument: ownerDocument,
    name: name,
    publicId: publicId,
    systemId: systemId
  });
}